import axios from "axios";
import { updateLocalStorageItem } from "@/utils/localStorage";
import { ESaleStatus } from "@/assets/status";

const url = process.env.VUE_APP_XMARTSHELF_ADMINISTRATION;

const state = {
  saleFilters: {
    inputText: null,
    payment_status: [],
    delivery_status: [],
    order_status: [],
    date: null
  },
  sales: null,
  selectedSaleId: null,
  selectedSale: null,
  selectedSales: null,
  saleToUpdate: null,
  loadingSales: false,
  paginationOptions: {
    itemsPerPage: 10,
    currentPage: 1,
    totalPages: 0,
    totalItems: undefined,
    filters: "all"
  },
  saleFilterOptions: [
    {
      id: "all",
      option: true,
      value: "all",
      text: "Todos os pedidos",
      show: true
    },
    {
      id: "pending",
      option: true,
      value: "pending",
      text: "Em andamento",
      show: true
    },
    {
      id: "done",
      option: true,
      value: "done",
      text: "Concluídas",
      show: true
    },
    {
      id: "refused",
      option: true,
      value: "refused",
      text: "Rejeitadas",
      show: true
    },
    {
      id: "give_up",
      option: true,
      value: "give_up",
      text: "Desistências",
      show: true
    },
    {
      id: "abandoned",
      option: true,
      value: "abandoned",
      text: "Abandonadas",
      show: true
    },
    {
      id: "refund",
      option: true,
      value: "refund",
      text: "Estornos",
      show: true
    },
    {
      id: "spacer",
      spacer: true,
      show: true
    },
    {
      id: "export",
      tools: true,
      text: "Exportar",
      show: false
    },
    {
      id: "change",
      tools: true,
      text: "Alterar status",
      show: true
    },
    {
      id: "cancel",
      tools: true,
      text: "Cancelar pedido",
      show: false
    }
  ],
  saleListSignal: null
};
const getters = {
  getSales(state) {
    return state.sales;
  },
  getTotalItems(state) {
    return state.paginationOptions.totalItems;
  },
  getSelectedSaleId(state) {
    return state.selectedSaleId;
  },
  getSelectedSale(state) {
    return state.selectedSale;
  },
  getSelectedSales(state) {
    return state.selectedSales;
  },
  getSalePaginationsOptions(state) {
    return state.paginationOptions;
  },
  skipAmount(state, getters) {
    return (
      (getters.getSalePaginationsOptions.currentPage - 1) *
      getters.getSalePaginationsOptions.itemsPerPage
    );
  },
  selectedSaleFilterStatus(state, getters) {
    return getters.getSalePaginationsOptions.filters;
  },
  allSaleFilterOptions(state) {
    return state.saleFilterOptions;
  },
  saleFilterStatus(state, getters) {
    switch (getters.selectedSaleFilterStatus) {
      case "pending":
        return [
          ESaleStatus.PENDING_PAYMENT,
          ESaleStatus.PAYMENT_MADE,
          ESaleStatus.REQUEST_REFUND_PAYMENT,
          ESaleStatus.PREPARING_DELIVERY,
          ESaleStatus.PARTIAL_DELIVERED,
          ESaleStatus.OUT_DELIVERY,
          ESaleStatus.WAITING_WITHDRAWAL,
          ESaleStatus.WAITING_WITHDRAWAL_LOCKER
        ];

      case "done":
        return [ESaleStatus.DELIVERY_MADE];

      case "refused":
        return [ESaleStatus.REFUSED_PAYMENT, ESaleStatus.CANCELED];

      case "give_up":
        return [ESaleStatus.GIVE_UP];

      case "abandoned":
        return [ESaleStatus.ABANDONED];

      case "refund":
        return [
          ESaleStatus.REQUEST_REFUND_PAYMENT,
          ESaleStatus.PAYMENT_PARTIAL_REFUNDED,
          ESaleStatus.PAYMENT_FULLY_REFUNDED
        ];

      default:
        return [
          ESaleStatus.CANCELED,
          ESaleStatus.PENDING_PAYMENT,
          ESaleStatus.PAYMENT_MADE,
          ESaleStatus.PREPARING_DELIVERY,
          ESaleStatus.PARTIAL_DELIVERED,
          ESaleStatus.OUT_DELIVERY,
          ESaleStatus.WAITING_WITHDRAWAL,
          ESaleStatus.WAITING_WITHDRAWAL_LOCKER,
          ESaleStatus.DELIVERY_MADE,
          ESaleStatus.REFUSED_PAYMENT,
          ESaleStatus.REQUEST_REFUND_PAYMENT,
          ESaleStatus.PAYMENT_FULLY_REFUNDED
        ];
    }
  },
  allSalesSelected(state) {
    if (!state.selectedSales) return false;
    return state.selectedSales.length === state.sales.length;
  },
  showSaleCancelButton(state, getters) {
    const selectedSales = getters.getSelectedSales;

    if (!selectedSales || selectedSales.length === 0) {
      return false;
    } else {
      return selectedSales.every(
        (sale) => sale.status === ESaleStatus.PENDING_PAYMENT
      );
    }
  },
  showSaleStatusButton(state, getters) {
    const selectedSales = getters.getSelectedSales;

    if (!selectedSales || selectedSales?.length === 0) {
      return false;
    } else if (
      selectedSales.some(
        (sale) =>
          sale.status === ESaleStatus.DELIVERY_MADE ||
          sale.status === ESaleStatus.CANCELED
      )
    ) {
      return false;
    } else {
      const { status, delivery_type } = selectedSales[0];

      return selectedSales.every(
        (item) => item.status === status && item.delivery_type === delivery_type
      );
    }
  },
  nextSaleBatchStatus(state, getters) {
    const selectedSales = getters.getSelectedSales;

    if (selectedSales?.length === 0) return null;

    switch (selectedSales[0].status) {
      case ESaleStatus.PAYMENT_MADE: // Pagamento aprovado -> Em separação
      case ESaleStatus.PREPARING_DELIVERY: // Em separação -> Saiu para entrega ou Aguardando retirada
      case ESaleStatus.PARTIAL_DELIVERED:
        return selectedSales[0].delivery_type === "home_delivery"
          ? {
              newStatus: ESaleStatus.OUT_DELIVERY,
              variant: "delivery"
            }
          : {
              newStatus: ESaleStatus.WAITING_WITHDRAWAL,
              variant: "delivery"
            };
      case ESaleStatus.PENDING_PAYMENT: // Aguardando pagamento -> Pagamento aprovado
        return {
          newStatus: ESaleStatus.PAYMENT_MADE,
          variant: "payment"
        };
      case ESaleStatus.REQUEST_REFUND_PAYMENT: // Aguardando estorno -> Estorno realizado
        return {
          newStatus: ESaleStatus.PAYMENT_FULLY_REFUNDED,
          variant: "payment"
        };
      default: // Qualquer outro status -> Entrega realizada
        return {
          newStatus: ESaleStatus.DELIVERY_MADE,
          variant: "delivery"
        };
    }
  },
  salesToUpdate(state) {
    return state.saleToUpdate;
  },
  isLoadingSales(state) {
    return state.loadingSales;
  },
  getSaleFilters(state) {
    return state.saleFilters;
  },
  getSaleListSignal(state) {
    return state.saleListSignal;
  }
};
const mutations = {
  setSales(state, payload) {
    state.sales = payload;
  },
  setSaleId(state, payload) {
    state.selectedSaleId = payload;
    updateLocalStorageItem("xmartshelf_admin", { selectedSale: payload });
  },
  setSale(state, payload) {
    state.selectedSale = payload;
  },
  setSelectedSales(state, payload) {
    state.selectedSales = payload;
  },
  setPagesAmount(state, amount) {
    state.paginationOptions.totalPages = amount;
  },
  setTotamItems(state, amount) {
    state.paginationOptions.totalItems = amount;
  },
  setFilterStatus(state, status) {
    state.paginationOptions.filters = status;
  },
  setCurrentPage(state, page) {
    state.paginationOptions.currentPage = page;
  },
  setSalesToUpdate(state, payload) {
    state.saleToUpdate = payload;
  },
  toogleLoadingSales(state, payload) {
    state.loadingSales = payload;
  },
  setSaleFilters(state, payload) {
    state.saleFilters = { ...state.saleFilters, ...payload };
  },
  setSaleListSignal(state, signal) {
    state.saleListSignal = signal;
  }
};
const actions = {
  loadSale({ commit, getters }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}/store/sale/${getters.getSelectedSaleId}`, {
          headers: {
            Authorization: `Bearer ${getters.getSessionToken}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then((response) => {
          commit("setSale", response.data);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  loadStoreSales({ commit, getters }) {
    return new Promise((resolve) => {
      const signal = new AbortController();

      if (getters.getSaleListSignal) {
        getters.getSaleListSignal.abort();
      }

      commit("setSaleListSignal", signal);

      const filterStatuses = getters.saleFilterStatus;
      const saleFilters = getters.getSaleFilters;
      let query = `skip=${getters.skipAmount}&take=10`;

      const { payment_status, delivery_status, order_status } = saleFilters;

      if (
        payment_status.length ||
        delivery_status.length ||
        order_status.length
      ) {
        const concat = payment_status.concat(delivery_status, order_status);

        const status = concat.join(",");

        query += `&status=${status}`;
      } else {
        query += `&status=${filterStatuses.join(",")}`;
      }

      const input_text = saleFilters.inputText;
      if (input_text) {
        query += `&input_text=${encodeURIComponent(input_text)}`;
      }

      if (saleFilters.date) {
        const startDateString = saleFilters.date.startDate
          .toISOString()
          .split("T")[0];
        const endDateString = saleFilters.date.endDate
          .toISOString()
          .split("T")[0];
        query += `&startDate=${startDateString}&endDate=${endDateString}`;
      }

      axios
        .get(
          `${url}/store/sales/store/${getters.getSelectedStore.store_id}?${query}`,
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            signal: signal.signal
          }
        )
        .then((response) => {
          commit("setSales", response.data.sales);
          commit("setTotamItems", response.data.total);
          commit("setPagesAmount", Math.ceil(response.data.total / 10));
          resolve({
            success: true,
            message: "Vendas carregadas com sucesso."
          });
        })
        .catch((error) => {
          console.log(error);
          resolve({
            success: false,
            message: "Erro ao carregar vendas."
          });
        });
    });
  },
  setUpdateSalesData({ commit, getters }, { saleData, cancel = false }) {
    return new Promise((resolve) => {
      if (!saleData) {
        const selectedSales = getters.getSelectedSales;

        if (selectedSales?.length === 0) return null;

        const data = {
          id: selectedSales.map((sale) => sale.id),
          oldStatus: selectedSales[0].status,
          newStatus: cancel
            ? ESaleStatus.CANCELED
            : getters.nextSaleBatchStatus.newStatus,
          variant: cancel ? "status" : getters.nextSaleBatchStatus.variant,
          storePick: selectedSales[0].delivery_type === "store_pick",
          physicalPayment: selectedSales[0].payment_method === "physical",
          cancel: cancel
        };

        commit("setSalesToUpdate", data);
      } else {
        commit("setSalesToUpdate", saleData);
      }

      resolve();
    });
  },
  updateSalesStatus({ commit, getters }) {
    return new Promise((resolve) => {
      const saleData = getters.salesToUpdate;
      axios
        .put(
          `${url}/store/sale/update_status`,
          {
            sale_id: saleData.id,
            status: saleData.newStatus,
            user_id: getters.getUserData.id
          },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          commit("setSelectedSales", null);
          commit("setSalesToUpdate", null);
          resolve({
            success: true,
            message: "Status das vendas atualizadas com sucesso."
          });
        })
        .catch((error) => {
          console.log(error);
          resolve({
            success: false,
            message: "Erro ao atualizar status das vendas."
          });
        });
    });
  },
  sendClientNotification({ getters }, notificationData) {
    return new Promise((resolve) => {
      axios
        .post(
          `${url}/notifications/email/custom`,
          {
            email: notificationData.email,
            subject: notificationData.subject,
            message: notificationData.message,
            project_name: "BMC"
          },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((message) => {
          resolve({
            success: true,
            message: message
          });
        })
        .catch((error) => {
          resolve({
            success: false,
            message: error.response.data.message
          });
        });
    });
  },
  cancelSales({ commit, getters }) {
    return new Promise((resolve) => {
      const saleData = getters.salesToUpdate;
      axios
        .put(
          `${url}/store/sales/cancel`,
          {
            sales_id: saleData.id,
            user_id: getters.getUserData.id
          },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          commit("setSelectedSales", null);
          commit("setSalesToUpdate", null);
          resolve({
            success: true,
            message: "Vendas canceladas com sucesso."
          });
        })
        .catch((error) => {
          console.log(error);
          resolve({
            success: false,
            message: "Erro ao cancelar vendas."
          });
        });
    });
  },
  selectAllSales({ commit, getters }) {
    if (getters.allSalesSelected) {
      commit("setSelectedSales", null);
    } else {
      commit("setSelectedSales", getters.getSales);
    }
  },
  sendInvoicesByEmail({ getters }) {
    return new Promise((resolve) => {
      const sale_id = getters.getSelectedSaleId;
      axios
        .post(
          `${url}/notifications/email/invoice/${sale_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((message) => {
          resolve({
            success: true,
            message: message
          });
        })
        .catch((error) => {
          resolve({
            success: false,
            message: error.response.data.message
          });
        });
    });
  },
  sendLockerByEmail({ getters }) {
    return new Promise((resolve) => {
      const sale_id = getters.getSelectedSaleId;
      axios
        .post(
          `${url}/notifications/email/locker/${sale_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((message) => {
          resolve({
            success: true,
            message: message
          });
        })
        .catch((error) => {
          resolve({
            success: false,
            message: error.response.data.message
          });
        });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
